import React from "react";

const PrintReportIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <g transform="translate(-47.367 -47.367)">
        <path
          d="M48.7,47.367A1.333,1.333,0,0,0,47.367,48.7V62.034A1.333,1.333,0,0,0,48.7,63.367h4.667V60.034a2,2,0,0,1,2-2V56.7a2,2,0,0,1,2-2H60.7V52.367a.666.666,0,0,0-.2-.471l-4.333-4.333a.666.666,0,0,0-.471-.2Zm6.667,1.271L59.43,52.7h-3.4a.668.668,0,0,1-.667-.667Zm2,7.4a.668.668,0,0,0-.667.667v1.333h6.667V56.7a.668.668,0,0,0-.667-.667Zm-1.333,3.333A1.333,1.333,0,0,0,54.7,60.7v2a1.333,1.333,0,0,0,1.333,1.333v1.333h8V64.034A1.333,1.333,0,0,0,65.367,62.7v-2a1.333,1.333,0,0,0-1.333-1.333Zm1.333,2H62.7v2.667H57.367Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export default PrintReportIcon;
